import { Component, HostListener, Input, ChangeDetectionStrategy } from '@angular/core';
import { HeaderFooterVariant } from '../../shared/enums/header-footer-variant.enum';

@Component({
  selector: 'lib-header-logo',
  templateUrl: './lib-header-logo.component.html',
  styleUrls: ['./lib-header-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibHeaderLogoComponent {
  @Input() title: string;
  @Input() headerFooterVariant: HeaderFooterVariant = HeaderFooterVariant.Default;
  innerWidth: number;

  constructor() {
    this.onResize();
  }

  @HostListener('window:resize')
  onResize(): void {
    this.innerWidth = window.innerWidth;
  }
}
